<template>
  <div class="inteBox">
    <intNavheader activeNameCheck="eight"></intNavheader>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div :class="activeName == 1 ? 'left-btn1' : 'left-btn2'" @click="changeState(1)">已预约</div>
        <div :class="activeName == 2 ? 'left-btn1' : 'left-btn2'" @click="changeState(2)">已完成</div>
        <div :class="activeName == -2 ? 'left-btn1' : 'left-btn2'" @click="changeState(-2)">已退号</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="iq-card-body">
            <div class="table-top flex-space-between">
              <el-page-header @back="goBack" content="挂号详情"> </el-page-header>
              <div class="flex-end">
                <div style="margin-left: 10px">
                  <el-button type="warning" size="small" @click="RefuseBtn" v-if="detailInfo.state == 1">退号</el-button>
                  <el-button type="primary" size="small" @click="confirmData" v-if="detailInfo.state == 1">确认到院</el-button>
                </div>
              </div>
            </div>
            <div class="table-line"></div>
            <div class="table-content">
              <div class="top-bg">
                <div class="top-info flex-space-between">
                  <div class="left-i">
                    <div class="flex-start">
                      <img style="width: 40px; height: 40px; border-radius: 50%" :src="`${Services.ossUpload}${detailInfo.photoFile}`" v-if="detailInfo.photoFile" />
                      <img v-else src="@/assets/img/touxiang03.png" />
                      <div style="margin-left: 5px">
                        <div class="flex-start">
                          <div class="doctor-1">{{ detailInfo.doctorName }} {{ detailInfo.departmentName }}</div>
                          <img style="margin-right: 5px" src="@/assets/img/rz_label.png" v-if="detailInfo.certificateNumber" />
                          <div class="doctor-bg2" v-if="detailInfo.userCategoryType == 1">专家</div>
                          <div class="doctor-bg2">{{ detailInfo.levelName }}</div>
                        </div>
                        <div class="hosptail">郑州大学第一附属医院</div>
                      </div>
                    </div>
                    <div class="info-div">
                      <div class="t1">
                        <img style="margin-right: 5px; margin-bottom: -3px" src="@/assets/img/wz_iconP01.png" />
                        <span style="margin-right: 5px">预约挂号费</span>
                        <span style="color: #00afb5; font-weight: bold">￥{{ detailInfo.payMoney ? detailInfo.payMoney.toFixed(2) : 0 }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="center-i">
                    <div class="t1">
                      <span class="t2">预约时间：</span>
                      <span class="right-desc">{{ detailInfo.scheduleDate.split('T')[0] }} {{ formatWeek(detailInfo.scheduleDate) }} {{detailInfo.timePeriod==1?'上午':'下午'}} {{ detailInfo.startTime}} ~ {{ detailInfo.endTime  }}</span>
                    </div>
                    <div class="t1">
                      <span class="t2">患者信息：</span>
                      <span class="right-desc">{{ detailInfo.patientName }} | {{detailInfo.patientType==0?'初诊':'复诊'}}</span>
                    </div>
                    <div class="t1">
                      <span class="t2">所患疾病：</span>
                      <span class="right-desc">{{ detailInfo.disease }}</span>
                    </div>
                  </div>
                  <div class="right-i">
                    <div style="color: #00afb5; font-weight: bold">
                      <span v-if="detailInfo.state == 1">已预约</span>
                      <span v-if="detailInfo.state == 2">已完成</span>
                      <span v-if="detailInfo.state == -2">已退号</span>
                    </div>
                  </div>
                </div>
                <div class="flex-start" style="margin-top: 15px">
                  <div class="top-1">
                    <span>订单编号：</span>
                    <span>{{ detailInfo.orderNumber }}</span>
                  </div>
                  <div class="top-1">
                    <span>下单时间：</span>
                    <span>{{ detailInfo.addTime | timefilters }}</span>
                  </div>
                  <div class="top-1">
                    <span>支付方式：</span>
                    <span v-if="detailInfo.payType == 0">余额</span>
                    <span v-if="detailInfo.payType == 1">微信</span>
                    <span v-if="detailInfo.payType == 2">支付宝</span>
                  </div>
                  <div class="top-1">
                    <span>支付时间：</span>
                    <span>{{ detailInfo.paySuccessTime | timefilters }}</span>
                  </div>
                  <div class="top-1">
                    <span>实付款：</span>
                    <span>合计 ￥ {{ detailInfo.payMoney ? detailInfo.payMoney.toFixed(2) : 0 }}</span>
                  </div>
                </div>
              </div>
              <div class="center-div">
                <div class="flex-start" style="margin-bottom: 8px">
                  <div class="line-left"></div>
                  <h3 style="font-weight: bold">医院信息</h3>
                </div>
                <div class="flex-start">
                  <img style="width: 40px; height: 40px; border-radius: 50%" :src="`${Services.ossUpload}${detailInfo.logoFile}`" v-if="detailInfo.logoFile" />
                  <img style="width: 40px; height: 40px; border-radius: 50%" v-else src="@/assets/img/login_img.png" />
                  <div style="margin-left: 5px">
                    <div class="flex-start">
                      <div class="doctor-1">{{ detailInfo.organizationName }}</div>
                      <div class="doctor-bg2">{{ detailInfo.levelName }}</div>
                      <div class="doctor-bg3" v-if="detailInfo.specialtyTypeName">{{ detailInfo.specialtyTypeName }}</div>
                      <div class="doctor-bg3" v-if="detailInfo.natureType == 1">公立医院</div>
                      <div class="doctor-bg3" v-if="detailInfo.natureType == 0">私立医院</div>
                    </div>
                    <div class="hosptail">{{ detailInfo.address }}</div>
                  </div>
                </div>
              </div>
              <div class="center-div">
                <div class="flex-start" style="margin-bottom: 8px">
                  <div class="line-left"></div>
                  <h3 style="font-weight: bold">医生信息</h3>
                </div>
                <div class="flex-start">
                  <img style="width: 40px; height: 40px; border-radius: 50%" :src="`${Services.ossUpload}${detailInfo.photoFile}`" v-if="detailInfo.photoFile" />
                  <img v-else src="@/assets/img/touxiang03.png" />
                  <div style="margin-left: 5px">
                    <div class="flex-start">
                      <div class="doctor-1">{{ detailInfo.doctorName }}</div>
                      <img style="margin-right: 5px" src="@/assets/img/rz_label.png" />
                      <div class="doctor-bg2" v-if="detailInfo.userCategoryType == 1">专家</div>
                    </div>
                    <div class="hosptail">{{ detailInfo.departmentName }} | {{ detailInfo.userTitleName }} | {{ detailInfo.userPostName }}</div>
                  </div>
                </div>
                <div class="doctor-bottom flex-space-between">
                  <div>
                    问诊量 <span style="color: #00afb5">{{ detailInfo.doctorEvaluateInfo?.orderCount }}</span>
                  </div>
                  <div class="small-line"></div>
                  <div>
                    好评率 <span style="color: #00afb5">{{ detailInfo.doctorEvaluateInfo?.goodRate }}</span>
                  </div>
                  <div class="small-line"></div>
                  <div>
                    评分 <span style="color: #00afb5">{{ detailInfo.doctorEvaluateInfo?.starRate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
    <el-dialog title="退号" :visible.sync="refuseDialog" width="450px">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refusalReason">
          <el-input v-model="refuseForm.refusalReason" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import intNavheader from "../../components/intNavheader";
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
export default {
  components: {
    intNavheader,
  },
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      userInfo: this.$store.state.localData.userInfo,
      detailInfo: {},
      DialogTitle: "收费",
      setDialog: false,
      formLabelWidth: "100px",
      orderId: this.$route.query.orderId,
      activeName: 1,
      form: {
        name: "",
        type: [],
        drug: [
          {
            edit: true,
            name: "",
            guidancePrice: null,
            membershipPrice: null,
            ordinaryPrice: null,
            stockNum: null,
            rank: null,
          },
        ],
      },
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      rules: {
        refusalReason: [{ required: true, message: "请填写退号原因", trigger: "blur" }],
      },
      refuseForm: {
        orderNumber: 0,
        refusalReason: "",
      },
      refuseDialog:false,
      formLabelWidth: "15px",
    };
  },
  created() {
    let activeName = JSON.parse(sessionStorage.getItem("activeName")) + "";
    if (activeName && activeName != "null") {
      sessionStorage.removeItem("activeName");
      this.activeName = activeName;
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    changeState(active) {
      this.activeName = active;
      this.goBack()
    },
    formatWeek(date) {
      const d = new Date(date);
      return this.weekdays[d.getDay()];
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    RefuseBtn(item) {
      var _this = this;
      _this.refuseDialog = true;
      _this.refuseForm = {
        orderNumber: item.orderNumber,
        refusalReason: "",
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          var item = this.refuseForm;
          _this.DoctorAppointment.DoctorRefundOrder(
            item.orderNumber,
            item.refusalReason,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.$refs[formName].resetFields();
              _this.refuseDialog = false;
              _this.getData();
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              // if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
              // }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirmData() {
      var _this = this;
      _this.DoctorAppointment.CompleteOrder(
        _this.orderId,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功！",
          });
          _this.goBack();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    getDetail() {
      var _this = this;
      _this.DoctorAppointment.OrderDetail(
        _this.orderId,
        function (data) {
          _this.detailInfo = data.data;
        },
        function (err) {}
      );
    },
    goBack() {
      sessionStorage.setItem("activeName", this.activeName);
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.pageBox {
  text-align: center;
  margin-top: 10px;
}

.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}

.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}

.titleTopLeftImg {
  width: 123px;
  height: 24px;
}

.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}

.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}

.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}

.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}

.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.titleTopRight div {
  margin-left: 10px;
}

.titleTopLine {
  width: 100%;
  height: 12px;
}

.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}

.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  // max-height: 750px;
  overflow: auto;
}

.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}

.titleTopCenterCenterTop {
  background-color: #ffffff;
  // padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
  overflow-y: auto;
}

.flex-l {
  display: flex;
  align-items: center;
}

.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Content1Title {
  padding: 20px 0;
  padding-left: 0;
  font-size: 18px;
  height: calc(100% - 20px);
  /* font-weight: bold; */

  color: #333333;
  padding-bottom: 0;
  text-align: left;
}

.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}

.ageInput {
  width: 80%;
}

.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}

.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}

.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}

.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}

.stepInput {
  width: 60%;
  margin-right: 10px;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.el-page-header {
  line-height: 73px;
  /* padding-left: 20px; */
}

.iq-card-body {
  padding: 0 0 15px;
  height: auto;
}

.table-top {
  width: 96%;
  margin: 0 auto;
}

.table-line {
  width: 100%;
  height: 6px;
  background: #f5f6f7;
  margin: 0 0 15px;
}

.table-content {
  padding: 0 30px;
  .top-bg {
    background: #f0f2f5;
    border-radius: 4px;
    padding: 20px 20px;
  }
  .top-info {
    background: #fff;
    padding: 15px 20px;
    border-radius: 10px;
    .t1 {
      margin-right: 30px;
    }

    .t2 {
    }
    .right-desc {
      font-weight: bold;
    }
    .right-i {
      margin-right: 10%;
    }

    .userName {
      margin-left: 10px;
      font-size: 20px;
      color: var(--base--Color);
    }

    .info-div {
      margin-top: 5px;
    }
  }
  .doctor-1 {
    font-weight: bold;
    margin-right: 5px;
  }
  .doctor-bg1 {
    margin-right: 5px;
  }
  .doctor-bg2 {
    background: #677aec;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
    margin-right: 5px;
    padding: 0 5px;
  }
  .hosptail {
    color: #666666;
  }
  .title {
    height: 60px;
    line-height: 60px;
    font-weight: bold;
  }
  .top-1 {
    margin-right: 3%;
  }
  .top-1 span:first-child {
    color: #999999;
  }
  .center-div {
    margin: 30px 0;
  }
  .doctor-bg3 {
    border-radius: 4px;
    border: 1px solid #00afb5;
    color: #00afb5;
    font-size: 10px;
    padding: 0 5px;
    margin-right: 5px;
  }
  .line-left {
    width: 4px;
    height: 16px;
    background: #666;
    margin-right: 10px;
  }
  .doctor-bottom {
    width: 320px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 2px 10px;
    margin-top: 10px;
  }
  .small-line {
    width: 1px;
    height: 14px;
    background: #999999;
  }
}

.PrintBox {
  width: 600px;
  background: #ffffff;
  font-size: 14px;
  padding: 20px;
  page-break-after: always !important;
  color: #333333;
}

.PrintBoxTitle {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}

.PrintBoxTitle1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PrintBoxTitle2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.PrintBoxTitleLine {
  width: 100%;
  height: 1px;
  background: #666666;
  margin: 5px 0;
  // margin-top: -2px;
  margin-right: 10px;
}

.PrintBoxTitleLineD {
  margin: 15px 0;
  border-bottom: 1px dashed #999999;
}

.printBox {
  visibility: visible !important;
  background-color: #adadad;
  color: #333333;
}

.printBox2 {
  visibility: visible !important;
  color: #333333;
}

.printBox3 {
  visibility: visible !important;
  color: #333333;
}

.print-d {
  ::v-deep .printTab .el-table__body-wrapper .el-table__cell {
    padding: 2px 0 !important;
  }
}

.print-d {
  width: 90%;
  margin: 0 auto;
  background: #ffffff;
  font-size: 14px;

  .p-t {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 20px;
    color: #333333;
  }

  .oneLine {
    margin: 10px 0 0 0;
    border-bottom: 1px dashed #999999;
  }

  .oneLine2 {
    margin: 10px 0;
    border-bottom: 1px solid #999999;
  }

  .twoLine {
    margin: 10px 0;
    height: 3px;
    border-top: 1px dashed #999999;
    border-bottom: 1px dashed #999999;
  }
}

.text-r {
  text-align: right;
}
</style>
